/**
 * Display link to ComputerShare SSO
 */

import processSsoViewTemplate from "./ProcessSsoViewTemplate";

var ProcessSsoDirective = function (samlTokenService, paeService, $location, $window, $modal) {
    return {
        restrict: "E",
        scope: {
            //Use custom-text in the attribute to change the link text.
            customText: "@",
            //factory-name attribute is the unique piece of the factory created
            //to retrieve the SAML Token. (IE "ComputerShare")
            factoryName: "@",
            //uniqueId is the string to append to the form id
            uniqueId: "@"
        },
        replace: true,
        template: processSsoViewTemplate,
        link: function (scope, element, attrs) {
            //This sets the function in the scope so it can be accessed by the template.
            scope.navigateToken = function (factoryName) {
                if (!scope.isPae)
                    $modal.open({
                        template:
                            "<saml-disclaimer factoryname='" +
                            scope.factoryName +
                            "' uniqueid='" +
                            scope.uniqueId +
                            "'><saml-disclaimer>"
                    });
                else {
                    //$location.path('/accessDeniedError/44403');
                    $window.location.href = "/participant/accounts/#/accessDeniedError/44403";
                }
            };

            //Checks to see if it is an image. If it is, the link will use the url.
            //If not, plain text will be displayed.
            scope.isImg = function () {
                var imgTypes = [".jpg", ".jpe", ".gif", ".png", ".svg", ".tif", ".bmp"];

                for (var i = 0; i <= imgTypes.length; i++) {
                    if (scope.customText.toLowerCase().indexOf(imgTypes[i]) > -1) return true;
                }
                return false;
            };

            var isPaePromise = paeService.checkPaeUser();
            isPaePromise.then(
                function (pae) {
                    scope.isPae = pae.partnerSSOResponse;
                },
                function (reason) {
                    scope.isPae = true;
                }
            );
        }
    };
};

ProcessSsoDirective.$inject = ["samlTokenService", "paeService", "$location", "$window", "$modal"];
export default ProcessSsoDirective;
